<template lang="pug">
.qmod-action-menu()
  VBtn(icon @click="toggleActionMenu"): i.material-icons.md-18 more_vert
  .qmod-action-menu-wrapper(v-if="showActionMenu" ref="actionmenu")
    .qmod-action-menu-watchlist(v-if="showWL")
      .qmod-action-menu-cont.qmod-action-menu-cont-watchlist(v-if="createnew")
        .qmod-action-menu-header(@click="createnew = false")
          i.material-icons.md-18 arrow_back
          span.qmod-action-menu-text Back
        .qmod-action-menu-body
          .qmod-action-menu-item
            VTextField(label="Create new watchlist" v-model="newWltoAdd" :error-messages="newloadingerror")
        .qmod-action-menu-footer
          VBtn(block color="primary" @click="createWatchlist" :loading="newwlLoading" :disabled="newwlLoading") Create watchlist and add
      .qmod-action-menu-cont.qmod-action-menu-cont-watchlist(v-else)
        .qmod-action-menu-header
          span.qmod-action-menu-text Add to watchlist
        .qmod-action-menu-body
          .qmod-action-menu-item(v-for="wl in watchlists")
            button.qmod-action-menu-button(@click="addSymbolToWatchlist(wl)")
              span.qmod-action-menu-text {{wl.name}}
              VTooltip.qmodii-ttip(v-if="wl.symbolExists" attach absolute)
                template(slot="activator")
                  i.material-icons.md-18(v-on="on") info
                span Symbol already exists in watchlist
              i.material-icons.md-18(v-else v-show="!wl.loading") add
              VProgressCircular(v-show="wl.loading" indeterminate color="primary")
        .qmod-action-menu-footer
          button.qmod-action-menu-button(@click="createnew = true;")
            span.qmod-action-menu-text Create new watchlist
            i.material-icons.md-18 chevron_right
    .qmod-action-menu-cont(v-if="showMenu")
      .qmod-action-menu-item(v-if="actionMenu.tradeEnabled" @click="$emit('ActionMenuClick', {type: 'trade', info: clickInfo})")
        button.qmod-action-menu-button
          i.material-icons.md-18 sync_alt
          span.qmod-action-menu-text Trade
      .qmod-action-menu-item(v-if="actionMenu.addToPortfolioEnabled" @click="$emit('ActionMenuClick', {type: 'addToPortfolio', info: clickInfo})")
        button.qmod-action-menu-button
          i.material-icons.md-18 markunread
          span.qmod-action-menu-text Add to portfolio
      .qmod-action-menu-item(v-if="actionMenu.addToWatchlistEnabled" @click="getWatchlists(clickInfo)")
        button.qmod-action-menu-button
          i.material-icons.md-18 control_point
          span.qmod-action-menu-text Add to watchlist
      .qmod-action-menu-item(v-if="actionMenu.addToAlertsEnabled" @click="$emit('ActionMenuClick', {type: 'addToAlerts', info: clickInfo})")
        button.qmod-action-menu-button
          i.material-icons.md-18 notifications
          span.qmod-action-menu-text Add to alerts
      .qmod-action-menu-item(v-if="actionMenu.detailedQuoteEnabled" @click="$emit('ActionMenuClick', {type: 'detailedQuote', info: clickInfo})")
        button.qmod-action-menu-button
          i.material-icons.md-18 attach_money
          span.qmod-action-menu-text View detailed quote
      .qmod-action-menu-item(v-if="actionMenu.chartForwardEnabled" @click="$emit('ActionMenuClick', {type: 'chartForward', info: clickInfo})")
        button.qmod-action-menu-button
          i.material-icons.md-18 bar_chart
          span.qmod-action-menu-text View charts
      .qmod-action-menu-item(v-if="actionMenu.optionChainEnabled" @click="$emit('ActionMenuClick', {type: 'optionChain', info: clickInfo})")
        button.qmod-action-menu-button
          i.material-icons.md-18 link
          span.qmod-action-menu-text View option chain
</template>

<script>
/* eslint-disable */
import {
  VBtn,
  VTooltip,
  VProgressCircular,
  VTextField
} from "vuetify/lib";
import axios from "axios";
export default {
  name: "ActionMenu",
  props: {
    actionMenu: {
      type: Object,
      required: false,
      default: false,
    },
    clickInfo: {
      type: Object,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      showActionMenu: false,
      showMenu: false,
      watchlists: [],
      showWL: false,
      symbolToAdd: null,
      createnew: false,
      newWltoAdd: '',
      newwlLoading: false,
      newloadingerror : ''
    }
  },
  methods:{
    async createWatchlist() {
      this.newloadingerror = '';
      this.newwlLoading = true;
      let body2 = {
        name: this.newWltoAdd
      };
     
      let URL2 = `//${this.$store.state.ENV}.quotemedia.com/ums/datatool/simple/watchlist/?wmid=${this.$store.state.WMID}&token=${
        this.$store.state.MarketScreener.componentToken
        }${
        this.$store.state.SID ? '&sid=' + this.$store.state.SID : ''
        }`;

        try {
        const response = await axios.post(URL2, body2);
    
        

        let body = {
          value: this.symbolToAdd,
          type: 'symbol',
          sequence: 0
        }
        let URL = `//${this.$store.state.ENV}.quotemedia.com/ums/datatool/simple/watchlist/${response.data.id}?wmid=${this.$store.state.WMID}&token=${
          this.$store.state.MarketScreener.componentToken
          }${
          this.$store.state.SID ? '&sid=' + this.$store.state.SID : ''
          }`;

        try {
          const response2 = await axios.post(URL, body);

          setTimeout(() => {
            this.newwlLoading = false;
            this.showWL = false;
          }, 250);
          }
          catch (e) {
          watchlist.loading = false;
        }
      }
      catch (e) {
        this.newloadingerror = e.response.data.error;
        this.newwlLoading = false;
      }
    },
    async getWatchlists(info) {
      this.symbolToAdd = this.$store.state.MarketScreener.CURRENT_SCREENER === 'mutual_fund' ? info.symbol : info.companyBasics.symbol;
      let URL = `//${this.$store.state.ENV}.quotemedia.com/ums/datatool/simple/watchlist/?wmid=${this.$store.state.WMID}&token=${
        this.$store.state.MarketScreener.componentToken
        }${
        this.$store.state.SID ? '&sid=' + this.$store.state.SID : ''
        }`;
        try {
          const response = await axios.get(URL);
          let WL = response.data.simpleWatchlists;
          WL.forEach(WLItem => {
            WLItem.loading = false;
            WLItem.simpleWatchlistItems.forEach(SWLItem => {
        
              if (SWLItem.value == this.symbolToAdd) {
             
                WLItem.symbolExists = true;
              }
            })
          })
          this.watchlists = response.data.simpleWatchlists;
          this.toggleWL()

        }
        catch (e) {

        }
    },
    async addSymbolToWatchlist(watchlist) {
      watchlist.loading = true;
      let body = {
        value: this.symbolToAdd,
        type: 'symbol',
        sequence: watchlist.simpleWatchlistItems.length == 0 ? 0 : watchlist.simpleWatchlistItems.length-1
      }
      let URL = `//${this.$store.state.ENV}.quotemedia.com/ums/datatool/simple/watchlist/${watchlist.id}?wmid=${this.$store.state.WMID}&token=${
        this.$store.state.MarketScreener.componentToken
        }${
        this.$store.state.SID ? '&sid=' + this.$store.state.SID : ''
        }`;

      try {
        const response = await axios.post(URL, body);
    
        
        setTimeout(() => {

          watchlist.loading = false;
          watchlist.symbolExists = true;
          this.showWL = false;
        }, 250);
  
      }
      catch (e) {
        watchlist.loading = false;
      }
    },
    toggleWL() {
    
      if (this.showWL == false) {
        
        this.$nextTick(() => {
          this.showWL = true;
          this.showMenu = false;
          // 
        });
        
      }
      else {
     
        this.showWL = false;
      }
    },
    toggle() {
      if (this.showMenu == false) {
        this.$nextTick(() => {
          this.showMenu = true;
          // document.addEventListener('click', this.dropdown)
        });        
      }
      else {
        this.showMenu = false;
        this.showWL = false;
      }
      // this.showMenu = !this.showMenu;
    },
    dropdown(e){
      let el = this.$refs.actionmenu;
      let target = e.target;

      if ((el && el !== target && !el.contains(target)) ){ //|| el2 && el2 !== target && !el2.contains(target)
        console.log('OUTSIDE OF MENU');
        this.showActionMenu = false
        this.showWL = false;
        this.showMenu = false;
 
        document.removeEventListener('click', this.dropdown)
      }
    },
    toggleActionMenu() {
 
      if (this.showActionMenu == false) {
        
        this.$nextTick(() => {
          this.showActionMenu = true;
          this.showMenu = true;
        });
        setTimeout(() => {
          document.addEventListener('click', this.dropdown)
        });
        
      }
      else {

        this.showActionMenu = false;
        this.showWL = false;
        document.removeEventListener('click', this.dropdown)
      }
    // this.showMenu = !this.showMenu;
    },
  },
  components: {
    VBtn,
    VTooltip,
    VProgressCircular,
    VTextField
  }
};
</script>

<style lang="stylus">
.qmod-action-menu
  .qmodii-ttip
    position relative
    .v-tooltip__content
      top 0 !important
      left auto !important
      right 0
  position relative
  .qmod-action-menu-wrapper
    right 10px
    top 40px
    display: flex;
    border: 1.5px solid #EEE;
    position: absolute;
    z-index: 9998;
    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
    background-color: #fff;
    border-radius: 4px;
    width: 300px;
    text-align: left;
    padding: 10px 0;
    flex-direction column
    .qmod-action-menu-cont-watchlist
      right 210px
      z-index: 9999
      .qmod-action-menu-button
        flex 1
        justify-content space-between
        .qmod-action-menu-text
         padding 0
    .qmod-action-menu-body
      max-height 450px;
      overflow-y auto
    .qmod-action-menu-item,
    .qmod-action-menu-header,
    .qmod-action-menu-footer
      display flex
      align-items center
      padding: 10px 20px;
    .qmod-action-menu-header
      font-weight bold
    .qmod-action-menu-footer
      font-weight bold
      border-top: 1px solid #E3E3E3;
    .qmod-action-menu-button
      display flex
      align-items center
      .qmod-action-menu-text
        padding-left 12px

</style>
